import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export class ExecReq extends Model {
  sessionId = "";
  saveData = new SaveData();
}
export class SaveData extends Model {
  name = ""; // 姓名
  idNumber = ""; // 身份证号
  imgUrl = ""; // 人脸照片
}

// 识别失败是否自动交卷
export enum LR_ERROR_AUTO_SUBMIT {
  YES = 1, // 自动交卷
  NO = 2 // 不自动交卷
}
export class ConfigData extends Model {
  lrErrorAutoSubmit: LR_ERROR_AUTO_SUBMIT = LR_ERROR_AUTO_SUBMIT.YES; // 识别失败是否自动交卷 2: 不自动交卷 1: 自动交卷
  lrRetryNumberLimit = 0; // 失败重试次数
}

export class ResponseData extends Model {
  number = 0; // 累计提交次数
  resultStatus: RESULT_STATUS = RESULT_STATUS.UNKNOWN; // 识别结果 0:未知 1:成功 2:失败(不可重试) 3:失败(可重试) 255:忽略
  message = ""; // 异常文案(对内)
  msg = ""; // 异常文案(对外)
  errorType = 0; // 异常类型 1:需要弹窗-重新认证按钮，拍摄页重新核验 2:需要弹窗-重新认证按钮，跳转到信息登记页
}

export class ResultData extends Model {
  name = ""; // 姓名
  idNumber = ""; // 身份证号
  imgUrl = ""; // 图片链接
  number = 0; // 累计提交次数
  resultStatus: RESULT_STATUS = RESULT_STATUS.UNKNOWN; // 识别结果 0:未知 1:成功 2:失败(不可重试) 3:失败(可重试) 255:忽略
  message = ""; // 异常文案(对内)
  msg = ""; // 异常文案(对外)
  errorType = 0; // 异常类型 1:需要弹窗-重新认证按钮，拍摄页重新核验 2:需要弹窗-重新认证按钮，跳转到信息登记页
}

// 识别结果
export enum RESULT_STATUS {
  UNKNOWN = 0, // 未知
  SUCCESS = 1, // 成功
  FAIL = 2, // 失败(不可重试)
  ERROR = 3, // 失败(可重试)
  IGNORE = 4 // 忽略
}

interface Param {
  paramId: string;
  value: string;
  name: string;
}

export class ExamInfo extends Model {
  examId = "";
  params = [] as Param[];
}

export class CandidateInfo extends Model {
  name = ""; // 候选人名称
  idNumber = ""; // 候选人身份证号
  phone = ""; // 候选人手机号
  candidateConnectCode = ""; // 候选人链接码
  signInfo = {} as any; // 登记成功后返回的信息
}

// 定向邀请，需要反显到页面上不可编辑的数据
export class ConnectCandidateData extends Model {
  phone = ""; // 候选人手机号
  showName = ""; // 候选人姓名
  idNumber = ""; // 候选人身份证号
}

interface SubmitReq {
  connectCode: string; // 候选人链接码
  isAutoSubmit: number; // 是否自动交卷，1 自动交卷
  autoType: number; // 交卷类型：4: 人脸核验失败，5: 人脸核验异常超过最大重试次数
}

// 交卷类型：4: 人脸核验失败，5: 人脸核验异常超过最大重试次数
export enum AUTO_TYPE {
  VERIFY_ERROR = 4,
  VERIFY_REACH_MAX_COUNT = 5
}

export default class FaceVerify extends Model {
  // 登记信息提交
  static create(p: any) {
    return request.post("aiExam/old/create", p).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
  // 登记信息后，开始面试前获取组件配置信息
  static getComponentInfoByCandidate(candidateConnectCode: string) {
    return request
      .post("aiExam/old/component", { candidateConnectCode }, false)
      .then(res => {
        if (res.data.code === 0) {
          return res.data.data;
        }
      });
  }
  // 自动交卷
  static submit(p: SubmitReq) {
    return request.post("aiExam/old/submit", p, false).then(res => {
      if (res.data.code === 0) {
        return res.data.data;
      }
    });
  }
}
